export enum ScalingMethod {
  ByWeight,
  ByVolume,
  ByLiquorVolume,
  Fixed,
  ByLiquorRation,
}
